import  { useEffect, useState } from 'react'
import BarChart from '../../components/chartTypes/Barchart';
import MultiSelectCheckboxGroup from '../../components/CheckBoxFilter';
import { generateOrginationEmiByState, generateOrginationEwiByState } from '../../services/originationByBranch';
import { TableBranchStateEMI, TableBranchState } from '../../components/TableBranchState';
import { baseURL } from '../../services';
import { useTranslation } from 'react-i18next';
import { sixMonthsAgoFormatted, twoDaysAgoFormatted } from '../../constants/intex';

const NewOriginationByBranchState = () => {
const { t } = useTranslation();

    const [selectedFilters, setSelectedFilters] = useState<Record<string, string[]>>(() => ({
        period: ["month"],
        fromDate: [sixMonthsAgoFormatted],
        toDate: [twoDaysAgoFormatted]
      }));
    const filters = [
      { key: "state", type: "select", label: t("filters.state") },
      // { key: "territory", type: "select", label: t("filters.territory") },
      { key: "cluster", type: "select", label: t("filters.cluster") },
      { key: "branch", type: "select", label: t("filters.branch")  },
      { key: "period", type: "singleSelect", label: t("filters.period") },
      { key: "fromDate", type: "date", label: t("filters.fromDate"), maxValue: selectedFilters.toDate },
      { key: "toDate", type: "date", label: t("filters.toDate"), maxValue: twoDaysAgoFormatted },
    ];
    const [applyFilter, setApplyFilter] = useState<boolean>(false);
    const [orginationEwiByState, setOrginationEwiByState] = useState<any[]>([]);
    const [orginationEmiByState, setOrginationEmiByState] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [orginationEmiByStateLoading, setOrginationEmiByStateLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    
    
  //handle filter change
    const handleFilterChange = (updatedValues: Record<string, string[]>) => {
      setSelectedFilters(updatedValues);
    };

    //Api to get New Origination EWI By Branch State table data
    const getGenerateOrginationEwiByState = async () => {
        setLoading(true);
        try {
          const response = await generateOrginationEwiByState(selectedFilters); // Call the API function
          setOrginationEwiByState(response.data); // Update state with user data
        } catch (err) {
          setError("Failed to fetch users");
          console.error(err);
        } finally {
          setLoading(false);
        }
      };

      //API to get New Origination EMI by Branch State table data
    const getGenerateOrginationEmiByState = async () => {
        setOrginationEmiByStateLoading(true);
        try {
          const response = await generateOrginationEmiByState(selectedFilters); // Call the API function
          setOrginationEmiByState(response.data); // Update state with user data
        } catch (err) {
          setError("Failed to fetch users");
          console.error(err);
        } finally {
          setOrginationEmiByStateLoading(false);
        }
      };
    //handle cancel click
    const handleCancelClick = () => {
      setSelectedFilters({
        period: ["month"],
        fromDate: [sixMonthsAgoFormatted],
        toDate: [twoDaysAgoFormatted]
      });
      setApplyFilter(!applyFilter)
    }
//Download button API
    const handleDownloadClick = () => {   
      const link = `${baseURL}/generate/csv/origination_summary_list_by_state_csv?from_date=${selectedFilters.fromDate ?? ""}&to_date=${selectedFilters.toDate ?? ""}&group_by=${selectedFilters.period ?? ""}&state_id=${selectedFilters.state ?? ""}&territory_id=${selectedFilters.territory ?? ""}&cluster_id=${selectedFilters.cluster ?? ""}&branch_id=${selectedFilters.branch ?? ""}`;
      window.location.href = link;
    }


      useEffect(() => {
          getGenerateOrginationEwiByState();
          getGenerateOrginationEmiByState()
      }, [applyFilter]);

  return (
    <div>
    {/* Page Content */}
    <div className="page-content">
      {/* Dynamic Grey Header */}
      <div className="header">
      {t('newOriginationBranchState.pageTitle')}
      </div>

      <div className="content px-3">
        <MultiSelectCheckboxGroup 
          filters={filters} 
          selectedValues={selectedFilters} 
          onChange={handleFilterChange} 
          isLoading={[loading, orginationEmiByStateLoading]}
          buttons={[
            { label:t("buttons.apply"), onClick: () => setApplyFilter(!applyFilter)},
            { label:t("buttons.cancel"), onClick: () => handleCancelClick()},
            { label: t("buttons.download"), onClick: () => handleDownloadClick()},
          ]}
        />
      </div>

       
        {/* New Origination EWI by branch */}
        <div className="row mt-5">
          <div className="col" style={{"overflow": "scroll", "width": "50%", "height": "55vh"}}>
              <h1 style={{ fontSize: 15, fontWeight: 600, fontFamily: 'Arial', fontStyle: 'normal', textAlign: "start", paddingLeft: "15px", color: '#14213d',}}>{t('newOriginationBranchState.New Origination EWI By Branch State')}</h1>
              <TableBranchState data={orginationEwiByState} loading={loading} />
              {/* <Pagination page={5} totalPages={10} handlePageChange={() => console.log("clicked")} /> */}
          </div>
          <div className="col-5 mt-5 p-3" style={{marginTop: "20px"}}>
            <BarChart 
                title={t('newOriginationBranchState.title1')}
                labels={orginationEwiByState?.map((obj) => obj.period)}
                dataSets={[
                  {
                    label: t('newOriginationBranchState.label1'),
                    data: orginationEwiByState?.map((obj) => {
                      // Extract the avg_loan_disb_amt from all categories within emi_loan_details
                      const emiData = obj?.ewi_loan_details[0];
                      if (emiData) {
                        // Extract avg_loan_disb_amt from each category
                        return [
                          emiData?.ticket_size_ewi || 0,
                        ];
                      }
                      return [0, 0, 0]; // Return default values if emi_loan_details is not available
                    }).flat(), // Flatten the array to create a single array of values
                    backgroundColor: "#0077b6",
                  },
                  {
                    label: t('newOriginationBranchState.label2'),
                    data: orginationEwiByState?.map((obj) => {
                      // Extract the avg_loan_disb_amt from all categories within emi_loan_details
                      const emiData = obj?.ewi_loan_details[1];
                      if (emiData) {
                        // Extract avg_loan_disb_amt from each category
                        return [
                          emiData?.ticket_size_ewi || 0,
                        ];
                      }
                      return [0, 0, 0]; // Return default values if emi_loan_details is not available
                    }).flat(), // Flatten the array to create a single array of values
                    backgroundColor: "#fca311",
                  },
                  // { label: "Kerala", data: [50000, 60000, 70000, 80000, 90000, 50000, 60000, 70000, 80000, 90000, 80000, 90000], backgroundColor: "#0077b6" },
                  // { label: "Tamil Nadu", data: [40000, 50000, 60000, 70000, 80000, 50000, 60000, 70000, 80000, 90000, 80000, 90000], backgroundColor: "#fca311" },
                ]}
                xLabel={t('newOriginationBranchState.xLabel')}
                yLabel={t('newOriginationBranchState.yLabel')}
            />
          </div>
        </div>

         {/* New Origination EMI */}
         <div className="row mt-5">
          <div className="col" style={{"overflow": "scroll", "width": "50%", "height": "55vh"}}>
              <h1 style={{ fontSize: 15, fontWeight: 600, fontFamily: 'Arial', fontStyle: 'normal', textAlign: "start", paddingLeft: "15px", color: '#14213d',}}>{t('newOriginationBranchState.New Origination EMI by Branch State')}</h1>
              <TableBranchStateEMI data={orginationEmiByState} loading={orginationEmiByStateLoading} />

              {/* <Table 
                  columns={drawDownColumns} 
                  data={drawdownData2} 
                  tableHead="New Origination EMI by Branch State"
                  type="2"
              /> */}
              {/* <Pagination page={5} totalPages={10} handlePageChange={() => console.log("clicked")} /> */}
          </div>
          <div className="col-5 mt-5 p-3" style={{marginTop: "20px"}}>
            <BarChart 
                title={t('newOriginationBranchState.title2')}
                labels={orginationEmiByState?.map((obj) => obj.period)}
                dataSets={[
                  {
                    label: t('newOriginationBranchState.label1'),
                    data: orginationEmiByState?.map((obj) => {
                      // Extract the avg_loan_disb_amt from all categories within emi_loan_details
                      const emiData = obj?.emi_loan_details[0];
                      if (emiData) {
                        // Extract avg_loan_disb_amt from each category
                        return [
                          emiData?.ticket_size_emi || 0,
                        ];
                      }
                      return [0, 0, 0]; // Return default values if emi_loan_details is not available
                    }).flat(), // Flatten the array to create a single array of values
                    backgroundColor: "#70e000",
                  },
                  {
                    label: t('newOriginationBranchState.label2'),
                    data: orginationEmiByState?.map((obj) => {
                      // Extract the avg_loan_disb_amt from all categories within emi_loan_details
                      const emiData = obj?.emi_loan_details[1];
                      if (emiData) {
                        // Extract avg_loan_disb_amt from each category
                        return [
                          emiData?.ticket_size_emi || 0,
                        ];
                      }
                      return [0, 0, 0]; // Return default values if emi_loan_details is not available
                    }).flat(), // Flatten the array to create a single array of values
                    backgroundColor: "#003f88",
                  },
                  // { label: "Kerala", data: [50000, 60000, 70000, 80000, 90000, 50000, 60000, 70000, 80000, 90000, 80000, 90000], backgroundColor: "#70e000" },
                  // { label: "Tamil Nadu", data: [40000, 50000, 60000, 70000, 80000, 50000, 60000, 70000, 80000, 90000, 80000, 90000], backgroundColor: "#003f88" },
                ]}
                xLabel={t('newOriginationBranchState.xLabel')}
                yLabel={t('newOriginationBranchState.yLabel')}
            />
          </div>
        </div>

      </div>
    </div>
  )
}

export default NewOriginationByBranchState;
